import { EmailAiSuggestionButtonFormModel } from '@/components/emailWindow/components/newEmail/components/aiSuggestionButton/components/dialog/model/EmailAiSuggestionButtonForm.model.ts';

export type NewEmailTranslation = {
  attachOffer: {
    button: string;
    dialog: {
      button: {
        attachOffer: string;
        attachRealization: string;
        close: string;
      };
      empty: string;
      title: string;
    };
  };
  autosave: {
    rejected: string;
    unavailable: string;
  };
  body: {
    attachment: {
      toast: {
        employeesUploadedGeneralError: string;
      };
    };
    bcc: string;
    body: string;
    button: {
      aiSuggestion: string;
    };
    cc: string;
    dialog: {
      aiSuggestion: {
        button: {
          cancel: string;
          submit: string;
        };
        form: Record<keyof EmailAiSuggestionButtonFormModel, string> & {
          instructionPlaceholder: string;
        };
        toast: { provideInstructions: string };
      };
    };
    dropzone: {
      button: {
        reset: string;
        upload: string;
      };
      disabled: string;
      label: string;
    };
    emailValidationFailed: string;
    subject: string;
    to: string;
    tooltip: {
      aiSuggestion: string;
    };
  };
  header: {
    button: {
      send: string;
    };
    tooltip: {
      close: string;
      dock: string;
      floating: string;
      minimize: string;
    };
  };
  previousMessages: string;
};

export const newEmailTranslation: NewEmailTranslation = {
  attachOffer: {
    button: 'Dołącz ofertę',
    dialog: {
      button: {
        attachOffer: '+ oferta',
        attachRealization: '+ realizacja',
        close: 'Zamknij',
      },
      empty: 'Ten proces nie ma żadnych grup ofert.',
      title: 'Wybierz ofertę do dołączenia',
    },
  },
  autosave: {
    rejected:
      'Nie udało się zapisać wersji roboczej — serwer odrzucił treść wiadomości. Najczęstsza przyczyna to obraz wklejony bezpośrednio do treści: taki obraz potrafi ważyć kilkanaście megabajtów. Usuń go z treści i dodaj jako załącznik.',
    unavailable:
      'Automatyczny zapis wersji roboczej został wstrzymany, bo serwer nie odpowiada. Skopiuj treść wiadomości, zanim zamkniesz okno.',
  },
  body: {
    attachment: {
      toast: {
        employeesUploadedGeneralError:
          'Nie udało się dołączyć pliku do wiadomości. Usuń załącznik i spróbuj dodać go jeszcze raz.',
      },
    },
    bcc: 'Ukryta kopia',
    body: 'Treść',
    button: {
      aiSuggestion: 'Generuj z AI',
    },
    cc: 'Kopia',
    dialog: {
      aiSuggestion: {
        button: {
          cancel: 'Anuluj',
          submit: 'Pobierz podpowiedź maila',
        },
        form: {
          addAttachments: 'Dodaj załączniki',
          addCafeRoyalInfo: 'Dodać informację o Royal Restaurant?',
          contentType: 'Typ wiadomości',
          instruction: 'Dodatkowe wytyczne',
          instructionPlaceholder:
            'Opcjonalne dodatkowe wytyczne, które będą uwzględnione przy generowaniu treści wiadomości',
        },
        toast: { provideInstructions: 'Podaj wytyczne dla generowanej wiadomości' },
      },
    },
    dropzone: {
      button: {
        reset: 'Usuń',
        upload: 'Dodaj',
      },
      disabled: 'Trwa wgrywanie pliku...',
      label: 'Upuść tu plik lub kliknij, aby wybrać z komputera',
    },
    emailValidationFailed: 'Niepoprawny adres email',
    subject: 'Temat',
    to: 'Do',
    tooltip: {
      aiSuggestion: 'Podaj przynajmniej jednego odbiorcę',
    },
  },
  header: {
    button: {
      send: 'Wyślij',
    },
    tooltip: {
      close: 'Zamknij',
      dock: 'Przypnij do okna',
      floating: 'Otwórz w oknie',
      minimize: 'Zminimalizuj',
    },
  },
  previousMessages: 'Wiadomości w wątku',
};
